import { render } from "./SideBarPane.vue?vue&type=template&id=690e0e15&scoped=true&ts=true"
import script from "./SideBarPane.vue?vue&type=script&lang=ts"
export * from "./SideBarPane.vue?vue&type=script&lang=ts"

import "./SideBarPane.vue?vue&type=style&index=0&id=690e0e15&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690e0e15"]])

export default __exports__